import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=05d1c43d&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d1c43d')) {
      api.createRecord('05d1c43d', component.options)
    } else {
      api.reload('05d1c43d', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=05d1c43d&", function () {
      api.rerender('05d1c43d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allocation_configs/edit.vue"
export default component.exports